import { useAppSelector } from 'hooks/reduxHooks'
import useCurrentMembershipYear from 'loyalty/hooks/useCurrentMembershipYear'
import calculateTierRemaining from 'loyalty/lib/calculateTierRemaining'
import getLoyaltyTierThresholds from 'loyalty/selectors/getLoyaltyTierThresholds'
import type { PlatinumRetentionMessageProps } from '../components/LoyaltyPlatinumRetentionMessage'

function useLoyaltyPlatinumRetention(): PlatinumRetentionMessageProps | undefined {
  const account = useAppSelector(state => state.loyalty.account.data)
  const loading = useAppSelector(state => state.loyalty.account.initial || state.loyalty.account.fetching)
  const thresholds = useAppSelector(getLoyaltyTierThresholds)
  const membershipYear = useCurrentMembershipYear()
  if (!account || account.tier !== 'platinum' || loading || !thresholds || !membershipYear || !account.statusReviewDate) return undefined

  const { creditsRemaining, nightsRemaining } = calculateTierRemaining(account, 'retain', thresholds)
  return {
    variant: membershipYear.retainVariant,
    creditsRemaining,
    nightsRemaining,
    targetCredits: thresholds.platinum.statusCredits,
    targetNights: thresholds.platinum.nights,
    reviewDate: account.statusReviewDate,
    reviewYearStart: membershipYear.reviewYearStart.toISOString(),
  }
}

export default useLoyaltyPlatinumRetention
